// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';
import { THForm } from '@Molecules/THForm/THForm';
import { THInput } from '@Molecules/Inputs/THInput/THInput';
import { THSwitch } from '@Molecules/Inputs/THSwitch/THSwitch';
import { THSelect } from '@Molecules/Inputs/THSelect/THSelect';
import { useLocalMessage } from '@Helpers/locale';

const nameKey = {
    ad: {
        hosts: ['hosts'],
        winDomain: ['winDomain'],
        dnsDomain: ['dnsDomain'],
        useSSL: ['useSSL'],
    },
};

export const resetFields = {
    hosts: [],
    winDomain: '',
    dnsDomain: '',
    useSSL: false,
};

const ConfigActiveDirectory = ({ availableProviders = [] }: { availableProviders?: string[] }): ReactElement => {
    const local = useLocalMessage();

    const notAvailable = !availableProviders?.includes('ad');

    return (
        <>
            <THForm.Item name={nameKey.ad.hosts} label={local('configPlateform.ad.hosts')}>
                <THSelect mode="tags" />
            </THForm.Item>
            <THForm.Item
                name={nameKey.ad.winDomain}
                label={local('configPlateform.ad.winDomain')}
                rules={[{ required: true }]}
            >
                <THInput disabled={notAvailable} />
            </THForm.Item>
            <THForm.Item
                name={nameKey.ad.dnsDomain}
                label={local('configPlateform.ad.dnsDomain')}
                rules={[{ required: true }]}
            >
                <THInput disabled={notAvailable} />
            </THForm.Item>
            <THForm.Item name={nameKey.ad.useSSL} label={local('configPlateform.ad.useSSL')} valuePropName="checked">
                <THSwitch disabled={notAvailable} />
            </THForm.Item>
        </>
    );
};

export default ConfigActiveDirectory;
